module.exports = __webpack_public_path__ + "img/buyIcon.60ce912e.png";